module.exports = __webpack_public_path__ + "static/img/logo_rio_.233773e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_rio_.png
// module id = 0lK3
// module chunks = 4